export default {
  'SET_GRAPH_TEMPLATES'(state, data) {
    state.graphTemplates = data;
  },
  'SET_GRAPH'(state, data) {
    state.graph = data;
  }
};